import { ILogic } from '@gongxigames/framework/slot/types';
import {
    GameSessionPromotionLogic,
    MultiSetsMulticampaignPromotionLogic,
    MultiSetsPromotionLogic,
    PromotionLogic,
    PromotionTypes,
    SingleSetPromotionLogic,
    IGameSessionPromotionInterface,
    IMultiSetsMulticampaignPromotionInterface,
    IMultiSetsPromotionInterface,
    IPromotionLogic,
    IPromotionLogicInterface,
    ISingleSetPromotionInterface,
} from '@gongxigames/framework/promotions';

export function createPromotionLogic<FR extends IPromotionLogicInterface>(promotionInterface: FR, logic: ILogic): IPromotionLogic {
    const type = promotionInterface.getType();

    if (type === PromotionTypes.GameSessionPromotion) {
        return new GameSessionPromotionLogic(promotionInterface as unknown as IGameSessionPromotionInterface, logic);
    }

    if (type === PromotionTypes.SingleSetPromotion) {
        return new SingleSetPromotionLogic(promotionInterface as unknown as ISingleSetPromotionInterface, logic);
    }

    if (type === PromotionTypes.MultiSetsPromotion) {
        return new MultiSetsPromotionLogic(promotionInterface as unknown as IMultiSetsPromotionInterface, logic);
    }

    if (type === PromotionTypes.MultiSetsMulticampaignPromotion) {
        return new MultiSetsMulticampaignPromotionLogic(promotionInterface as unknown as IMultiSetsMulticampaignPromotionInterface, logic);
    }

    return new PromotionLogic(promotionInterface, logic);
}
